import React, {
  ReactElement,
  PropsWithChildren,
  useRef,
  useEffect,
} from "react";
import mainMobile from "../../assets/img/main-mobile.png";
import game from "../../assets/img/slider/game.png";
import prepaid from "../../assets/img/slider/prepaid.png";
import travel from "../../assets/img/slider/travel.png";
import tablet from "../../assets/img/slider/tablet.png";
import wallet from "../../assets/img/slider/wallet.png";
import qrScanMobile from "../../assets/img/qr-scan-mobile.png";
import { ReactComponent as CirculeIcon } from "../../assets/img/svgicons/circle.svg";
import { ArrowRightIcon } from "../../assets/img/svgicons";
import card from "../../assets/img/card.png";
import shadowMoile from "../../assets/img/shadow.png";
import multiSevicesMobile from "../../assets/img/multi-services-mobile.png";
import moneyTransferMobile from "../../assets/img/money-transfer-mobile.png";
import prepaidMobileImg from "../../assets/img/services/prePaid/h-prepaid.png";
import travelMobileImg from "../../assets/img/services/travel/h-travel.png";
import gamepinMobileImg from "../../assets/img/services/gamePin/h-gamepin.png";
import billpaymentMobileImg from "../../assets/img/services/billPayment/h-billpayment.png";
import useSectionStyles, {
  SectionBuilderClasses,
} from "../Home/SectionBuilder/styles";
import {
  QrCodeIcon,
  MoneyTransferIcon,
  AppleStoreWhiteIcon,
  PlayStoreMultiColorIcon,
  ArrowTopIcon,
  AndroidIconGreen,
  PrepaidIcon,
  BillPaymentIcon,
  GamePinLargeIcon,
  TravelIcon,
} from "../../assets/img/svgicons";
import useHomeStyles, { HomeClasses } from "./styles";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation } from "swiper";
import { TweenMax, gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import DownloadIconBuilder from "../../components/DownloadIconBuilder";
import { useTranslation } from "react-i18next";
import { servicesData } from "../../translation";
import { Link } from "react-router-dom";
import "./swiper.css";

gsap.registerPlugin(ScrollTrigger);

SwiperCore.use([Autoplay, Navigation]);

export type HomeProps = {};

export type SectionBuilderProps = {
  sectionDirection?: "rtl" | "ltr";
  sectionMargin?: Array<number>;
  contentBoxPadding?: Array<number>;
};

function Mobile({
  sectionDirection = "rtl",
  sectionMargin = [],
  contentBoxPadding = [],
}: PropsWithChildren<SectionBuilderProps>): ReactElement {
  const SectionStyles: SectionBuilderClasses = useSectionStyles({
    sectionDirection,
    contentBoxPadding,
    sectionMargin,
  });

  const servicesDataEn: any = servicesData.en;
  const servicesDataTr: any = servicesData.tr;
  let [activeServices, setActiveServices] = React.useState(servicesDataEn);
  let [shadowMobileImageLoaded, setShadowMobileImageLoaded] = React.useState(
    false
  );
  const { t, i18n } = useTranslation();
  const useStyles: HomeClasses = useHomeStyles({ shadowMobileImageLoaded });

  const lang = i18n.language;

  const mounted = useRef();
  useEffect(() => {
    if (!mounted.current) {
      if (lang === "en") {
        setActiveServices(servicesDataEn);
      } else {
        setActiveServices(servicesDataTr);
      }
    }
  }, [lang, servicesDataEn, servicesDataTr]);

  const mainImgeMobileRef = useRef<HTMLImageElement>(null);
  const mainImgeCardRef = useRef<HTMLImageElement>(null);
  const circuleIconRef = useRef<SVGSVGElement>(null);
  const mainContentTitleRef = useRef<HTMLHeadingElement>(null);
  const mainDescRef = useRef<HTMLHeadingElement>(null);
  const mainMoileImageShadowRef = useRef<HTMLImageElement>(null);

  // const mainContentDescRef = useRef<HTMLHeadingElement>(null);
  const sliderSectionTitleTextRef = useRef<HTMLHeadingElement>(null);
  const qrCodeimgLogoRef = useRef<HTMLImageElement>(null);
  const prepaidContentBoxRef = useRef<HTMLDivElement>(null);
  const travelImgLogoRef = useRef<HTMLImageElement>(null);
  const travelContentBoxRef = useRef<HTMLDivElement>(null);
  const billPaymentImgLogoRef = useRef<HTMLImageElement>(null);
  const billPaymentContentBoxLogoRef = useRef<HTMLDivElement>(null);
  const gamePinContentBoxLogoRef = useRef<HTMLDivElement>(null);
  const gamePinImgLogoRef = useRef<HTMLImageElement>(null);
  // const backToTopRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (
      mainImgeMobileRef &&
      mainImgeMobileRef.current &&
      mainImgeCardRef &&
      mainImgeCardRef.current &&
      circuleIconRef &&
      circuleIconRef.current &&
      mainContentTitleRef &&
      mainContentTitleRef.current &&
      mainDescRef &&
      mainDescRef.current &&
      mainMoileImageShadowRef &&
      mainMoileImageShadowRef.current &&
      // backToTopRef &&
      // backToTopRef.current &&
      // mainContentDescRef &&
      // mainContentDescRef.current &&
      sliderSectionTitleTextRef &&
      sliderSectionTitleTextRef.current &&
      qrCodeimgLogoRef &&
      qrCodeimgLogoRef.current &&
      prepaidContentBoxRef &&
      prepaidContentBoxRef.current &&
      travelImgLogoRef &&
      travelImgLogoRef.current &&
      travelContentBoxRef &&
      travelContentBoxRef.current &&
      billPaymentImgLogoRef &&
      billPaymentImgLogoRef.current &&
      billPaymentContentBoxLogoRef &&
      billPaymentContentBoxLogoRef.current &&
      gamePinContentBoxLogoRef &&
      gamePinContentBoxLogoRef.current &&
      gamePinImgLogoRef &&
      gamePinImgLogoRef.current
    ) {
      // back to top
      // let backToTopAnimation = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: backToTopRef.current,
      //     start: "top 0",
      //     end: "bottom bottom",
      //     toggleActions: "pause play pause reverse",
      //   },
      // });
      // backToTopAnimation.from(backToTopRef.current, {
      //   x: 500 + 100,
      //   duration: 1.2,
      //   opacity: 0,
      // });

      // show images
      TweenMax.fromTo(
        mainImgeMobileRef.current,
        0.5,
        {
          opacity: 0,
          y: -50,
          duration: 3,
        },
        { opacity: 1, delay: 0.8, y: 0 }
      );

      TweenMax.fromTo(
        mainMoileImageShadowRef.current,
        0.5,
        {
          opacity: 0,
          y: -50,
          duration: 3,
        },
        { opacity: 1, delay: 0.8, y: 0 }
      );

      TweenMax.fromTo(
        mainImgeCardRef.current,
        0.7,
        {
          opacity: 0,
          y: -60,
        },
        { opacity: 1, y: 0, delay: 1.3 }
      );
      TweenMax.fromTo(circuleIconRef.current, 0.8, { scale: 0 }, { scale: 1 });
      //  Title & Desc
      gsap.from(mainContentTitleRef.current, {
        y: -180,
        duration: 1,
        opacity: 0,
        scrollTrigger: {
          trigger: mainContentTitleRef.current,
          start: "top center",
          end: "bottom center",
          toggleActions: "play resume compelete reverse",
        },
      });
      gsap.from(mainDescRef.current, {
        y: -180,
        duration: 1,
        opacity: 0,
        scrollTrigger: {
          trigger: mainDescRef.current,
          start: "top center",
          end: "bottom center",
          toggleActions: "play resume compelete reverse",
        },
      });

      // gsap.from(mainContentDescRef.current, {
      //   y: -180,
      //   duration: 1,
      //   delay: 0.6,
      //   opacity: 0,
      //   scrollTrigger: {
      //     trigger: mainContentDescRef.current,
      //     start: "top 400px",
      //     end: "bottom center",
      //     toggleActions: "play resume compelete reverse",
      //   },
      // });
      //   slider Title
      gsap.from(sliderSectionTitleTextRef.current, {
        duration: 0.5,
        scale: 0.5,
        opacity: 0,
        scrollTrigger: {
          trigger: sliderSectionTitleTextRef.current,
          start: "top 450px",
          end: "bottom center",
          toggleActions: "play resume compelete reverse",
        },
      });
      //  qr code
      gsap.from(qrCodeimgLogoRef.current, {
        // y: -150,
        duration: 1,
        scale: 1.1,
        scrub: true,
        opacity: 0,

        scrollTrigger: {
          // markers: true,
          trigger: qrCodeimgLogoRef.current,
          endTrigger: prepaidContentBoxRef.current,
          start: "top 70%",
          end: "bottom bottom",
          toggleActions: "play resume compelete reverse",
        },
      });
      gsap.from(prepaidContentBoxRef.current, {
        duration: 0.8,
        filter: "blur(2px)",
        opacity: 0,
        delay: 0.1,
        scrollTrigger: {
          trigger: prepaidContentBoxRef.current,
          start: "top 75%",
          end: "bottom bottom",
          toggleActions: "play resume compelete reverse",
        },
      });
      //   multi services
      gsap.from(travelImgLogoRef.current, {
        // y: -150,
        duration: 1,
        scale: 1.1,
        opacity: 0,
        scrollTrigger: {
          trigger: travelImgLogoRef.current,
          endTrigger: travelContentBoxRef.current,
          start: "0% center",
          end: "bottom bottom",
          toggleActions: "play resume compelete reverse",
        },
      });
      gsap.from(travelContentBoxRef.current, {
        duration: 0.8,
        filter: "blur(2px)",
        opacity: 0,
        delay: 0.1,
        scrollTrigger: {
          trigger: travelContentBoxRef.current,
          start: "0% 70%",
          end: "bottom bottom",
          toggleActions: "play resume compelete reverse",
        },
      });
      // game pin
      gsap.from(gamePinImgLogoRef.current, {
        // y: -150,
        duration: 1,
        scale: 1.1,
        opacity: 0,
        scrollTrigger: {
          trigger: gamePinImgLogoRef.current,
          endTrigger: gamePinContentBoxLogoRef.current,
          start: "top 70%",
          end: "bottom bottom",
          toggleActions: "play resume compelete reverse",
        },
      });
      gsap.from(gamePinContentBoxLogoRef.current, {
        duration: 0.8,
        filter: "blur(2px)",
        opacity: 0,
        delay: 0.1,
        scrollTrigger: {
          trigger: gamePinContentBoxLogoRef.current,
          start: "top 70%",
          end: "bottom",
          toggleActions: "play resume compelete reverse",
        },
      });
      // bill payment
      gsap.from(billPaymentImgLogoRef.current, {
        // y: -150,
        duration: 1,
        scale: 1.1,
        opacity: 0,
        scrollTrigger: {
          trigger: billPaymentImgLogoRef.current,
          endTrigger: billPaymentContentBoxLogoRef.current,
          start: "top 70%",
          end: "bottom bottom",
          toggleActions: "play resume compelete reverse",
        },
      });
      gsap.from(billPaymentContentBoxLogoRef.current, {
        duration: 0.8,
        filter: "blur(2px)",
        opacity: 0,
        delay: 0.1,
        scrollTrigger: {
          trigger: billPaymentContentBoxLogoRef.current,
          start: "top 70%",
          end: "bottom",
          toggleActions: "play resume compelete reverse",
        },
      });
    }
  }, []);
  const goToTopPageHandler = () => {
    window.scroll({ top: 0, behavior: "smooth" });
  };

  const checkFullLoadedImgShadowMobile = () => {
    setTimeout(() => {
      setShadowMobileImageLoaded(true);
    }, 500);
  };
  return (
    <>
      {/* <button
        onClick={goToTopPageHandler}
        className={useStyles.backToTopPage}
        ref={backToTopRef}
      >
        <ArrowTopIcon width="18" style={{ opacity: "0.8" }} />
      </button> */}
      <section className={useStyles.mainSection}>
        <div className={useStyles.mainContainer}>
          <div className={useStyles.mainWrapper}>
            <div className={useStyles.mainContentBox}>
              <h2
                className={useStyles.mainContentTitle}
                ref={mainContentTitleRef}
              >
                {t("mainTitle")}
                {/* <span className={useStyles.mainContentTitleSuperpay}>Pay</span> */}
              </h2>
              <h4 className={useStyles.mainContentDesc} ref={mainDescRef}>
                {t("mainDesc")}
              </h4>
              {/* <div className={useStyles.mainContentStartedBox}>
                <div
                  className={useStyles.getAppLabel}
                  style={{ margin: "10px" }}
                >
                  {t("downloadAppLabel")}
                </div>

                <DownloadIconBuilder
                  link="#"
                  icon={<PlayStoreMultiColorIcon width="24" height="30" />}
                  descText={"GET IN THE"}
                  mainText={"GooglePlay"}
                  padding="8px 22px 8px 10px"
                  bgColor="#212227"
                />

                <DownloadIconBuilder
                  link="#"
                  icon={<AppleStoreWhiteIcon width="22" height="30" />}
                  descText={"Available on the"}
                  mainText={"App Store"}
                  margin="5px 0 5px 0"
                  padding="8px 35px 8px 10px"
                  bgColor="#212227"
                />

                <DownloadIconBuilder
                  link="#"
                  icon={<AndroidIconGreen width="26" height="26" />}
                  descText={"Directly Download"}
                  mainText={"For Free"}
                  padding="10px 26px 10px 12px"
                  bgColor="#212227"
                />
              </div> */}
            </div>
            <div className={useStyles.mainImageBox}>
              <CirculeIcon
                width="400px"
                className={useStyles.circuleIcon}
                ref={circuleIconRef}
              />
              <img
                src={card}
                alt=""
                className={useStyles.mainImgeCard}
                ref={mainImgeCardRef}
              />
              <div className="mainMoileImageBox">
                <img
                  src={shadowMoile}
                  onLoad={checkFullLoadedImgShadowMobile}
                  alt=""
                  className={`${useStyles.mainImgeMobileShadowMoile}`}
                  ref={mainMoileImageShadowRef}
                />
                <img
                  src={mainMobile}
                  alt=""
                  className={useStyles.mainImgeMobile}
                  ref={mainImgeMobileRef}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section Slider */}
      <section className={SectionStyles.sliderSectionTitle}>
        <h4
          className={SectionStyles.sliderSectionTitleText}
          ref={sliderSectionTitleTextRef}
        >
          {t("hedlineSlider")}
        </h4>
        <div>
          <Swiper
            slidesPerView={2}
            className={useStyles.swiperContainer}
            autoplay
            navigation
          >
            <SwiperSlide className={useStyles.swiperSlide}>
              <Link to="/services/game-pin">
                <img src={game} alt="" className={useStyles.swiperSlideImage} />
              </Link>
              <Link
                to="/services/game-pin"
                className={SectionStyles.contentDetailsLink}
              >
                <span className={useStyles.swiperSlideText}>
                  {t("gamePinService")}
                </span>
                <ArrowRightIcon
                  className={useStyles.arrowRightIcon}
                  width="15px"
                />
              </Link>
            </SwiperSlide>
            <SwiperSlide className={useStyles.swiperSlide}>
              <Link to="/services/prepaid">
                <img
                  src={prepaid}
                  alt=""
                  className={useStyles.swiperSlideImage}
                />
              </Link>
              <Link
                to="/services/prepaid"
                className={SectionStyles.contentDetailsLink}
              >
                <span className={useStyles.swiperSlideText}>
                  {t("prepaidService")}
                </span>
                <ArrowRightIcon
                  className={useStyles.arrowRightIcon}
                  width="15px"
                />
              </Link>
            </SwiperSlide>
            <SwiperSlide className={useStyles.swiperSlide}>
              <Link to="/services/travel">
                <img
                  src={travel}
                  alt=""
                  className={useStyles.swiperSlideImage}
                />
              </Link>
              <Link
                to="/services/travel"
                className={SectionStyles.contentDetailsLink}
              >
                <span className={useStyles.swiperSlideText}>
                  {t("travelService")}
                </span>
                <ArrowRightIcon
                  className={useStyles.arrowRightIcon}
                  width="15px"
                />
              </Link>
            </SwiperSlide>
            <SwiperSlide className={useStyles.swiperSlide}>
              <Link to="/services/bill-payment">
                <img
                  src={tablet}
                  alt=""
                  className={useStyles.swiperSlideImage}
                />
              </Link>
              <Link
                to="/services/bill-payment"
                className={SectionStyles.contentDetailsLink}
              >
                <span className={useStyles.swiperSlideText}>
                  {t("billPaymentService")}
                </span>
                <ArrowRightIcon
                  className={useStyles.arrowRightIcon}
                  width="15px"
                />
              </Link>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
      <div className={useStyles.container}>
        {/* Section 1 */}
        <section
          className={SectionStyles.section}
          style={{ margin: "0 0 0 0" }}
        >
          <div className={SectionStyles.wrapper}>
            <div>
              <div>
                <img
                  src={prepaidMobileImg}
                  alt=""
                  className={SectionStyles.imgLogo}
                  ref={qrCodeimgLogoRef}
                />
              </div>
            </div>
            <div>
              <div
                className={SectionStyles.contentBox}
                style={{ padding: "0 0 0 105px" }}
                ref={prepaidContentBoxRef}
              >
                <i className={SectionStyles.contentIconBox}>
                  <PrepaidIcon width="50px" />
                </i>
                <h2 className={SectionStyles.contentTitle}>
                  {activeServices.prepaid.title}
                </h2>
                <h4 className={SectionStyles.contentDesc}>
                  {activeServices.prepaid.text}
                </h4>
                <div
                  className={useStyles.spContentFaqTitle}
                  // ref={sectionOneFaqTitleRef}
                >
                  {activeServices.prepaid.benefitsTitle}
                </div>
                <ul
                  className={useStyles.spContentFaqList}
                  // ref={sectionOneFaqListRef}
                >
                  {activeServices.prepaid.benefits
                    ? activeServices.prepaid.benefits.map((item: any) => {
                        return <li key={item.id}>{item.text}</li>;
                      })
                    : ""}
                </ul>
                <Link
                  to="/services/prepaid"
                  className={SectionStyles.contentDetailsLink}
                >
                  <span className={SectionStyles.contentDetailsText}>
                    {t("learnMoreText")}
                  </span>
                  <ArrowRightIcon width="15px" />
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* Section 2 */}
        <section
          className={SectionStyles.section}
          style={{ margin: "80px 0 0 0" }}
        >
          <div
            className={SectionStyles.wrapper}
            style={{ flexDirection: "row-reverse", padding: "0 0 0 50px" }}
          >
            <div>
              <div>
                <img
                  src={travelMobileImg}
                  alt=""
                  className={SectionStyles.imgLogo}
                  ref={travelImgLogoRef}
                />
              </div>
            </div>
            <div>
              <div
                className={SectionStyles.contentBox}
                ref={travelContentBoxRef}
              >
                <i className={SectionStyles.contentIconBox}>
                  <TravelIcon width="70px" />
                </i>
                <h2 className={SectionStyles.contentTitle}>
                  {activeServices.billPayment.title}
                </h2>
                <h4 className={SectionStyles.contentDesc}>
                  {activeServices.billPayment.text}
                </h4>
                <div
                  className={useStyles.spContentFaqTitle}
                  // ref={sectionTwoFaqTitleRef}
                >
                  {activeServices.travel.benefitsTitle}
                </div>
                <ul
                  className={useStyles.spContentFaqList}
                  // ref={sectionTwoFaqListRef}
                >
                  {activeServices.travel.benefits
                    ? activeServices.travel.benefits.map((item: any) => {
                        return <li key={item.id}>{item.text}</li>;
                      })
                    : ""}
                </ul>
                <Link
                  to="/services/travel"
                  className={SectionStyles.contentDetailsLink}
                >
                  <span className={SectionStyles.contentDetailsText}>
                    {t("learnMoreText")}
                  </span>
                  <ArrowRightIcon width="15px" />
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* Section 3 */}
        <section
          className={SectionStyles.section}
          style={{ margin: "80px 0 0 0" }}
        >
          <div className={SectionStyles.wrapper}>
            <div>
              <div>
                <img
                  src={gamepinMobileImg}
                  alt=""
                  className={SectionStyles.imgLogo}
                  ref={gamePinImgLogoRef}
                />
              </div>
            </div>
            <div>
              <div
                className={SectionStyles.contentBox}
                style={{ padding: "0 0 0 105px" }}
                ref={gamePinContentBoxLogoRef}
              >
                <i className={SectionStyles.contentIconBox}>
                  <GamePinLargeIcon width="60px" />
                </i>
                <h2 className={SectionStyles.contentTitle}>
                  {activeServices.gamePin.title}
                </h2>
                <h4 className={SectionStyles.contentDesc}>
                  {activeServices.gamePin.text}
                </h4>
                <div
                  className={useStyles.spContentFaqTitle}
                  // ref={sectionThreeFaqTitleRef}
                >
                  {activeServices.gamePin.benefitsTitle}
                </div>
                <ul
                  className={useStyles.spContentFaqList}
                  // ref={sectionThreeFaqListRef}
                >
                  {activeServices.gamePin.benefits
                    ? activeServices.gamePin.benefits.map((item: any) => {
                        return <li key={item.id}>{item.text}</li>;
                      })
                    : ""}
                </ul>
                <Link
                  to="/services/game-pin"
                  className={SectionStyles.contentDetailsLink}
                >
                  <span className={SectionStyles.contentDetailsText}>
                    {t("learnMoreText")}
                  </span>
                  <ArrowRightIcon width="15px" />
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* Section 4 */}
        <section
          className={SectionStyles.section}
          style={{ margin: "80px 0 0 0" }}
        >
          <div className={SectionStyles.wrapper}>
            <div>
              <div>
                <img
                  src={billpaymentMobileImg}
                  alt=""
                  className={SectionStyles.imgLogo}
                  ref={billPaymentImgLogoRef}
                />
              </div>
            </div>
            <div>
              <div
                className={SectionStyles.contentBox}
                style={{ padding: "0 0 0 105px" }}
                ref={billPaymentContentBoxLogoRef}
              >
                <i className={SectionStyles.contentIconBox}>
                  <BillPaymentIcon width="60px" />
                </i>
                <h2 className={SectionStyles.contentTitle}>
                  {activeServices.billPayment.title}
                </h2>
                <h4 className={SectionStyles.contentDesc}>
                  {activeServices.billPayment.text}
                </h4>
                <div
                  className={useStyles.spContentFaqTitle}
                  // ref={sectionFourFaqTitleRef}
                >
                  {activeServices.billPayment.benefitsTitle}
                </div>
                <ul
                  className={useStyles.spContentFaqList}
                  // ref={sectionFourFaqListRef}
                >
                  {activeServices.billPayment.benefits
                    ? activeServices.billPayment.benefits.map((item: any) => {
                        return <li key={item.id}>{item.text}</li>;
                      })
                    : ""}
                </ul>
                <Link
                  to="/services/bill-payment"
                  className={SectionStyles.contentDetailsLink}
                >
                  <span className={SectionStyles.contentDetailsText}>
                    {t("learnMoreText")}
                  </span>
                  <ArrowRightIcon width="15px" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Mobile;
